module.exports = __webpack_public_path__ + "static/media/26.f67270d7.jpeg";